class mCheckoutStepper extends HTMLDivElement {
    constructor() {
        super();

        const checkoutMain = document.getElementById('checkout-main');
        if (checkoutMain) {
            this.setCheckoutStage(checkoutMain.dataset.checkoutStage);
        }

        document.addEventListener('checkout:stageChange', (e) => {
            this.setCheckoutStage(e.detail.stage);
        });
    }

    setCheckoutStage(stage) {
        this.checkoutStage = stage === 'customerModify' ? 'customer' : stage;

        this.querySelectorAll('.stepper-step').forEach((stepEl) => {
            const itemEl = stepEl.parentElement;
            if (stepEl.dataset.stage === this.checkoutStage) {
                stepEl.setAttribute('aria-current', 'step');
                itemEl.classList.add('current');
            } else {
                stepEl.removeAttribute('aria-current');
                itemEl.classList.remove('current');
            }
        });
    }
}

customElements.define('m-checkout-stepper', mCheckoutStepper, {
    extends: 'div',
});
